import { ClassAttributes, createElement, useContext } from 'react';
import { RouteComponentProps } from 'react-router';

import RouteLifecycleWrapper from '../component/primitive/RouteLifecycleWrapper';
import { context as DependencyContext } from '../context/dependency';
import { context as StateContext } from '../context/state';
import { NewCreationPage as _NewCreationPage } from '../page/NewCreationPage';

type UrlParams = {
  creationSetId: string;
  assignmentId: string;
  creativeFormatId: string;
};

type Props = ClassAttributes<HTMLElement> & RouteComponentProps<UrlParams>;

export const NewCreationPage = ({ match }: Props) => {
  const dependency = useContext(DependencyContext);
  const state = useContext(StateContext);
  return (
    <RouteLifecycleWrapper
      onMount={async () => {
        dependency.authenticationUsecase.needSignedIn();
      }}
      onUnmount={() => {}}
    >
      <_NewCreationPage
        creationSetId={match.params.creationSetId}
        creativeFormatId={match.params.creativeFormatId}
        assignmentId={match.params.assignmentId}
        onCreated={(creationId: string) => {
          dependency.history.push(`/creations/${creationId}`);
        }}
        language={state.language}
        prepareProject={async (projectId: string) => {
          await dependency.showProjectUsecase.prepare(projectId);
        }}
      />
    </RouteLifecycleWrapper>
  );
};
